
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { format } from "date-fns";
import { Tables } from "@/integrations/supabase/types";
import { Badge } from "@/components/ui/badge";

interface ExpenseWithCategory extends Omit<Tables<"expenses">, "house_id"> {
  entity_id: string;
  entity_type: 'house' | 'plot';
  expense_categories: {
    name: string;
  };
  houses?: {
    name: string;
  };
}

interface ExpenseTableProps {
  expenses: Array<ExpenseWithCategory>;
}

export const ExpenseTable = ({ expenses }: ExpenseTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="text-base w-[20%]">Entidad</TableHead>
          <TableHead className="text-base w-[20%]">Categoría</TableHead>
          <TableHead className="text-base w-[40%]">Descripción</TableHead>
          <TableHead className="text-base w-[20%] text-right">Monto</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {expenses.map((expense) => (
          <TableRow key={expense.id}>
            <TableCell className="text-base">
              <div className="flex items-center gap-2">
                {expense.houses?.name || "—"}
                {expense.entity_type && (
                  <Badge variant={expense.entity_type === 'house' ? 'outline' : 'secondary'} className="text-xs">
                    {expense.entity_type === 'house' ? 'Casa' : 'Parcela'}
                  </Badge>
                )}
              </div>
            </TableCell>
            <TableCell className="text-base">{expense.expense_categories.name}</TableCell>
            <TableCell className="text-base">{expense.description || "-"}</TableCell>
            <TableCell className="text-base text-right">
              ${expense.amount.toLocaleString('es-ES', { maximumFractionDigits: 0 }).replace(/,/g, '.')}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
